import type { HelpFile } from '../../types/help'
import { ClusterNodesTestIds } from '../../../testids/ClusterNodesTestIds'

export const clusterNodesHelp: HelpFile = {
  docPage: '/docs/admin/cluster',
  texts: {
    [ClusterNodesTestIds.clusterNodesCard]:
      'Active nodes in the application cluster — health status and load distribution.',
    [ClusterNodesTestIds.colActions]: null,
    [ClusterNodesTestIds.colHostname]: null,
    [ClusterNodesTestIds.colIpAddress]: null,
    [ClusterNodesTestIds.colLastHeartbeat]:
      'Most recent heartbeat from this node — stale heartbeats indicate the node may be down.',
    [ClusterNodesTestIds.colNodeId]: null,
    [ClusterNodesTestIds.colRegistered]: null,
    [ClusterNodesTestIds.colStatus]: null,
    [ClusterNodesTestIds.masterNodeId]:
      'Node currently acting as cluster master — responsible for coordinating scheduled jobs.',
  },
}
